import { Alert, Button, Modal, Spinner, Stack } from "react-bootstrap";

import DocumentCollectionForm from "./document_collection_form";
import { useDocumentCollectionData } from './use_document_collection_data';

export function DocumentCollectionLayout(props) {
  const { show, onHide } = props;
  const {
    loanDetails,
    documentsList,
    documentTypesList,
    loading,
    loadError,
    retryLoad,
    reloadLoanDetails,
    reloadDocumentsList,
  } = useDocumentCollectionData();

  // Filter only external documents (exclude internal)
  const externalDocumentTypes = documentTypesList?.filter(doc => !doc.is_internal);
  const externalDocuments = documentsList?.filter(doc => !doc.document_type?.is_internal);

  return (
    <Modal
      show={show}
      onHide={() => onHide(false)}
      backdrop="static"
      keyboard={false}
      size="xl"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      data-testid="fincobox-upload-modal"
    >
      <Modal.Header>
        <Modal.Title style={{ fontSize: '18px' }}>Upload Documents</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          data-testid="fincobox-upload-modal-close"
          onClick={() => onHide(false)}
        />
      </Modal.Header>

      <Modal.Body className="px-4">
        <Stack gap={3} style={{ width: '100%' }}>
          <div className="_inKycHead">
            <h1>General Information</h1>
            <p>Please fill the form in order to apply for loan.</p>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
                <Spinner animation="border" role="status" />
                <span className="ms-2">Fetching data...</span>
              </div>
            )
              : loadError ? (
                <div
                  className="d-flex flex-column justify-content-center align-items-center text-center"
                  style={{ minHeight: "400px" }}
                  data-testid="fincobox-upload-load-error"
                >
                  <Alert variant="danger" className="mb-3">
                    We couldn't load your application details. Please check your connection and try again.
                  </Alert>
                  <Button variant="primary" onClick={retryLoad} data-testid="fincobox-upload-load-retry">
                    Retry
                  </Button>
                </div>
              )
              : (
                <DocumentCollectionForm
                  afterSubmit={onHide}
                  loanDetails={loanDetails}
                  reloadLoanDetails={reloadLoanDetails}
                  loading={loading}
                  documentTypesList={externalDocumentTypes}
                  documentsList={externalDocuments}
                  reloadDocumentsList={reloadDocumentsList}
                />
              )
          }
        </Stack>
      </Modal.Body>
    </Modal>
  );
}
